import axios, { CancelTokenSource } from "axios";
import { NAVIGATION_PAGE_SIZE } from "consts";
import { RecordsListItem } from "fe-shared/src/types/common";
import { DataGridRequestParams, Invoice, InvoiceMaterialRaw } from "fe-shared-transactions/src/types";
import { mapMaterialsWithUnits } from "fe-shared-transactions/src/helpers/mapMaterialsWithUnits";
import { getMappedTransactions } from "fe-shared-transactions/src/helpers/getMappedTransactions";
import { RawInvoiceTransaction } from "fe-shared-transactions/src/types/invoice";

export interface NavigationInvoice {
    invoiceId: number;
    invoiceNumber: string;
}

export interface NavigationInvoices {
    total: number;
    invoicesIds: NavigationInvoice[];
}

export interface AddNoteParams {
  text: string;
  invoiceId: number;
}

export interface InvoiceListInfo {
  isPresent: boolean;
  currentInvoiceIndex: number;
}

export const getInvoice = (queryKey: string, invoiceNumber: string, cancelToken: CancelTokenSource) =>
  axios
    .get<Invoice>("invoices/rate", {
      params: { invoiceNumber },
      cancelToken: cancelToken?.token,
    })
    .then(({ data }) => {
      const {
        transactions,
        unidentifiedMaterials,
        paymentBalanceAdjustments,
        ...rest
      } = data;

      return {
        ...rest,
        transactions: getMappedTransactions(
          (transactions as unknown) as RawInvoiceTransaction[]
        ),
        unidentifiedMaterials: mapMaterialsWithUnits(
          (unidentifiedMaterials as unknown) as InvoiceMaterialRaw[]
        ),
        paymentBalanceAdjustments,
        balanceAdjustmentsSubTotal: paymentBalanceAdjustments.reduce(
          (sum, balanceAdjustment) => sum + balanceAdjustment.amount,
          0
        ),
      };
    });
export const approveInvoiceFirstTime = ({ invoiceId }: any): Promise<any> =>
  axios.post("invoices/firstapprove", { invoiceId }).then((res) => res.data);

export const approveInvoiceSecondTime = ({ invoiceId }: any): Promise<any> =>
  axios.post("invoices/secondapprove", { invoiceId }).then((res) => res.data);

export const postInvoiceToGP = ({ invoiceId }: any): Promise<any> =>
  axios.post("invoices/postToGp", { invoiceId }).then((res) => res.data);

export const cancelInvoice = ({ invoiceId }: any): Promise<any> =>
  axios.post("invoices/cancel", { invoiceId }).then((res) => res.data);

export const getNavigationInvoices = (
    queryKey: string,
    requestParams: DataGridRequestParams,
    page: number | null = 1
) =>
    axios
        .post<NavigationInvoices>("getInvoicesIds", {
            ...requestParams,
            ...(page !== null
                ? {
                    limit: NAVIGATION_PAGE_SIZE,
                    skip: NAVIGATION_PAGE_SIZE * (page - 1),
                }
                : {}),
        })
        .then((res) => res.data);

export const getInvoiceListInfo = (queryKey: string, 
  invoiceNumber: string, 
  requestParams: DataGridRequestParams,
  cancelToken: CancelTokenSource): Promise<InvoiceListInfo> => 
    axios
    .post<InvoiceListInfo>("getInvoiceListInfo", 
      {
        invoiceNumber,
        ...requestParams,
         }, {
        cancelToken: cancelToken?.token}
    )
    .then((res) => res.data);

export const addInvoiceNote = ({ text, invoiceId }: AddNoteParams) =>
  axios
    .post(
      "invoices/Notes",
      { text },
      { params: { invoiceId }, hideToast: true }
    )
    .then((res) => res.data);

export const getInvoiceNotes = (
  invoiceId: number
): Promise<RecordsListItem[]> =>
  axios
    .get("invoices/Notes", {
      params: { invoiceId },
    })
    .then((res) => res.data);
